import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

class NotFound extends Component {
  render(){
    return (
        <>
        <h1>お探しのページは見つかりませんでした。</h1>
        <div>
            <Link to={`/`}>ホームに戻る</Link>
        </div>
        </>
    );
  }
};

export default NotFound;